import { Link } from "react-router-dom";
import { Clock, ThumbsUp, ChevronRight } from "lucide-react";
import { topicMeta } from "@/lib/topicMeta";

export const PopularArticlesList = ({ articles }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-3">
      {articles.map((a, i) => {
        const { Icon, color, bg } = topicMeta(a.topic_icon);
        return (
          <Link
            key={a.id}
            to={`/article/${a.slug}`}
            data-testid="popular-article-item"
            className="group flex items-start gap-4 bg-white rounded-xl border border-slate-200 p-4 sm:p-5 hover:border-slate-300 hover:shadow-md transition-all animate-fade-up"
            style={{ animationDelay: `${i * 40}ms` }}
          >
            <span
              className="grid place-items-center w-10 h-10 rounded-lg shrink-0"
              style={{ backgroundColor: bg, color }}
            >
              <Icon className="w-5 h-5" />
            </span>
            <div className="min-w-0 flex-1">
              <div className="text-xs font-semibold text-slate-400 mb-0.5">
                {a.topic_name} <span className="text-slate-300">›</span> {a.section}
              </div>
              <h4 className="font-medium text-slate-900 leading-snug group-hover:text-[#1A73E8] transition-colors">
                {a.title}
              </h4>
              <div className="flex items-center gap-4 mt-2 text-xs text-slate-500">
                <span className="inline-flex items-center gap-1">
                  <Clock className="w-3.5 h-3.5" /> {a.read_time} min read
                </span>
                <span className="inline-flex items-center gap-1">
                  <ThumbsUp className="w-3.5 h-3.5" /> {a.helpful_yes.toLocaleString()} found helpful
                </span>
              </div>
            </div>
            <ChevronRight className="w-5 h-5 text-slate-300 group-hover:text-slate-500 self-center shrink-0" />
          </Link>
        );
      })}
    </div>
  );
};
